import React, { useEffect } from 'react';
import HeroSection from '../sections/HeroSection';
import CareSpotlightSection from '../sections/CareSpotlightSection';
import WhyUsSection from '../sections/WhyUsSection';
import FeaturedPupsSection from '../sections/FeaturedPupsSection';
import WhyMarysPlushPupsSection from '../sections/WhyMarysPlushPupsSection';

export default function HomePage({ heroMainImage, heroFloating, contact, whyForYou, pets, onViewCatalogue }) {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (!el) return;
    setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
  }, []);

  return (
    <>
      <HeroSection
        heroMainImage={heroMainImage}
        heroFloating={heroFloating}
        whatsappUrl={contact.whatsappUrl}
        onViewPups={onViewCatalogue}
      />

      <CareSpotlightSection
        onApplyWhatsApp={() => {
          const text =
            "Hi Mary’s Plush Pups! I’d love to apply for one of the newborn babies.\\n\\nMy favorite baby name idea: ____\\n\\nPlease share availability and next steps (pickup/shipping).";
          const url = `${contact.whatsappUrl}?text=${encodeURIComponent(text)}`;
          window.open(url, '_blank', 'noreferrer');
        }}
        onViewCatalogue={onViewCatalogue}
      />

      <WhyMarysPlushPupsSection
        brand={contact.name}
        whatsappUrl={contact.whatsappUrl}
        onViewCatalogue={onViewCatalogue}
      />
      <WhyUsSection brand={contact.name} whyForYou={whyForYou} />
      <FeaturedPupsSection pets={pets} onViewCatalogue={onViewCatalogue} />
    </>
  );
}
